var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddbuttoninblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5H7V1.5C7 1.23478 6.89464 0.98043 6.70711 0.792893C6.51957 0.605357 6.26522 0.5 6 0.5C5.73478 0.5 5.48043 0.605357 5.29289 0.792893C5.10536 0.98043 5 1.23478 5 1.5V5.5H1C0.734784 5.5 0.48043 5.60536 0.292893 5.79289C0.105357 5.98043 0 6.23478 0 6.5C0 6.76522 0.105357 7.01957 0.292893 7.20711C0.48043 7.39464 0.734784 7.5 1 7.5H5V11.5C5 11.7652 5.10536 12.0196 5.29289 12.2071C5.48043 12.3946 5.73478 12.5 6 12.5C6.26522 12.5 6.51957 12.3946 6.70711 12.2071C6.89464 12.0196 7 11.7652 7 11.5V7.5H11C11.2652 7.5 11.5196 7.39464 11.7071 7.20711C11.8946 7.01957 12 6.76522 12 6.5C12 6.23478 11.8946 5.98043 11.7071 5.79289C11.5196 5.60536 11.2652 5.5 11 5.5Z",
    fill: "#056EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddbuttoninblue);
export default __webpack_public_path__ + "static/media/addbuttoninblue.d31887b82f6e1fd392c434283821c2ba.svg";
export { ForwardRef as ReactComponent };